import Icon, { type IconName } from '@cobliteam/colib-ui/Icon';
import { useLanguage } from '@cobliteam/i18n';
import { getTextForLanguage } from '@cobliteam/ui-business/utils';
import { iconColorClass } from '@cobliteam/ui-business/utils/iconColorClass';
import { getSingular } from '@cobliteam/utils/pluralize';
import { memo } from 'react';
import type { PageWithCategory } from '../../../types';

interface PageItemProps {
  item: PageWithCategory;
}

export const PageItem = memo(({ item }: PageItemProps) => {
  if (!item) return null;
  const { currentLanguage } = useLanguage();
  const itemTitle = getTextForLanguage(item.title, currentLanguage);
  const title = item?.group ? `${getSingular(item.group)} - ${getSingular(itemTitle || '')}` : `${getSingular(itemTitle || '')}`;

  return (
    <button type='button' tabIndex={0} className={'flex w-full items-center justify-between text-xs'}>
      <div className='flex items-center justify-center gap-2'>
        {item.category.loading ? (
          <Icon size='sm' name='loader-circle' className='size-3 animate-spin' />
        ) : (
          <Icon size='sm' name={(item.sidebar?.icon as IconName) || item.category.icon} className={iconColorClass(item.category.color)} />
        )}
        <div className='flex flex-col text-left'>
          <span className='text-[10px] text-muted-foreground'>
            {getSingular(item.category.name)} {item?.primary ? `- ${getSingular(item?.primary || '')}` : ''}
          </span>
          <span className='line-clamp-1'>{title}</span>
        </div>
      </div>
    </button>
  );
});
